import React from 'react'
import { FormControl, Grid, InputLabel, MenuItem, Select, Button } from '@mui/material'
import AutoCompleteComponent from '../../component/Autocomplete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormTextField from '../../component/EditRowForm';


const ModbusAddModal = ({
    open,
    fields,
    onClose,
    inputRef,
    rowIndex,
    changeHandler,
    modbusOptions,
    autoCompleteOptions,
    autoCompleteLoading,
    handleAddModalFormData,
    handleChangeAutoComplete,
    handleSearchValueAutoComplete,
}) => {

  return (
    <Dialog closeAfterTransition={false} fullWidth maxWidth={'md'} open={open} onClose={onClose}>
        <DialogTitle>{rowIndex ? 'Edit' : 'Add'} Modbus Address </DialogTitle>
        <DialogContent>
            <Grid container direction="row" spacing={2}>
                <Grid item xs={12} sm={4} md={4}>
                    <FormTextField
                        className={'fieldFullWidth'}
                        id="RegAddr"
                        label="Modbus Address"
                        name="RegAddr"
                        value={fields.RegAddr || ''}
                        onBlurUpdate={changeHandler}
                        type='modbus'
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                    <FormControl
                        margin="dense"
                        fullWidth
                    >
                        <InputLabel id="demo-simple-select-standard-label">Sheet</InputLabel>
                        <Select
                            labelId="demo-simple-select-standard-label"
                            id="demo-simple-select-standard"
                            sx={{
                                "&:focus": {
                                    backgroundColor: "#ffffff"
                                }
                            }}
                            label="Sheet"
                            value={fields.Sheet || ''}
                            onChange={(event) => changeHandler(event.target.name,event.target.value)}
                            name="Sheet"
                        >
                            <MenuItem value="">Select Sheet</MenuItem>
                            {modbusOptions?.map((opt) => (
                                <MenuItem key={opt.value} value={opt.value}>{opt.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                    <AutoCompleteComponent
                        label="Search Text"
                        options={autoCompleteOptions}
                        loading={autoCompleteLoading}
                        handleChangeAutoComplete={handleChangeAutoComplete}
                        inputRef={inputRef}
                        handleSearchValueAutoComplete={handleSearchValueAutoComplete} />
                </Grid>
            </Grid>
            <Grid>
                <span className="modbusNote">Note - For Modbus Address use range between 1-9999 and 40001-49999 only. </span>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button 
                variant="contained"
                size="medium"
                color="primary" 
                onClick={handleAddModalFormData}
            >Submit</Button>
            <Button 
                variant="contained"
                size="medium"
                color="error" 
                onClick={onClose}
            >Close</Button>
        </DialogActions>
    </Dialog>
  )
}

export default ModbusAddModal